module.exports = __webpack_public_path__ + "img/company-logo-designs.3b9e5617.jpg";